import { message } from 'ant-design-vue';
import axios from 'axios';

import { blobToJson } from '../common';
import { HttpCode } from './constants';
import HttpResponseError from './http-response-error';

const http = axios.create({
  baseURL: process.env.VUE_APP_API_HOST,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

http.interceptors.response.use(async (response) => {
  // 如果返回类型是blob，且服务返回的不是application/json类型，直接返回response
  if (response.config.responseType === 'blob') {
    if (response.data.type === 'application/json') {
      response.data = JSON.parse((await blobToJson(response.data)) as string);
    } else {
      return response;
    }
  }

  const { code, data } = response.data;
  if (code === HttpCode.Ok) return data;

  if (code === HttpCode.Unauthorized) {
    if (process.env.NODE_ENV === 'development') {
      console.error(`请使用测试环境登录：${process.env.VUE_APP_API_HOST_TEST}/login`);
    } else {
      const callback = window.encodeURIComponent(window.location.href);
      window.location.href = `${process.env.VUE_APP_API_HOST}/login?callback=${callback}`;
    }
  } else if (code === HttpCode.Forbidden) {
    message.error('没有权限');
  }

  return Promise.reject(new HttpResponseError(response));
});

export default http;
